import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "tedops.trendAlerts.dismissed";
const id = (a) => `${a.keyword}|${a.week}`;

export function TrendAlerts() {
  const { can } = useAuth();
  const [list, setList] = useState([]);
  const [gone, setGone] = useState(() => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } });
  useEffect(() => {
    if (can("customers.view")) api.get("/marketing/trends/alerts").then((r) => setList(r.data.alerts || [])).catch(() => {});
  }, [can]);
  const dismiss = (a) => { const n = [...gone, id(a)].slice(-50); setGone(n); localStorage.setItem(KEY, JSON.stringify(n)); };
  const show = list.filter((a) => !gone.includes(id(a)));
  if (!show.length) return null;
  return (
    <div className="space-y-2 mb-6" data-testid="dashboard-trend-alerts">
      {show.map((a) => (
        <div key={id(a)} className="flex items-start gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3" data-testid={`trend-alert-${a.keyword}`}>
          <span className="w-8 h-8 rounded-xl bg-emerald-600 text-white flex items-center justify-center shrink-0"><TrendingUp className="w-4 h-4" /></span>
          <div className="flex-1 min-w-0 text-sm">
            <p className="font-semibold text-emerald-900">Searches for "{a.keyword}" are up {a.change_pct}% in the last 4 weeks</p>
            <p className="text-xs text-emerald-800 mt-0.5">
              {a.vs_last_year_pct != null ? `${a.vs_last_year_pct >= 0 ? "+" : ""}${a.vs_last_year_pct}% vs the same weeks last year. ` : "Higher than the same weeks last year. "}
              Good time to launch a {a.category || a.keyword} campaign.{" "}
              <Link to="/marketing/trends" className="font-medium underline hover:text-emerald-950" data-testid={`trend-alert-open-${a.keyword}`}>See trends</Link>
            </p>
          </div>
          <button onClick={() => dismiss(a)} className="p-1 rounded-lg text-emerald-700 hover:bg-emerald-100" aria-label="Dismiss" data-testid={`trend-alert-dismiss-${a.keyword}`}><X className="w-4 h-4" /></button>
        </div>
      ))}
    </div>
  );
}
